import { notification } from "antd";

export default {
  success: (title, message) => {
    notification.success({
      message: title,
      description: message,
      placement: "top",
    });
  },
  info: (title, message) => {
    notification.info({
      message: title,
      description: message,
      placement: "top",
    });
  },
  error: (title, message) => {
    notification.error({
      message: title,
      description: message,
      placement: "top" 
    });
  },
  warning: (title, message) => {
    notification.warning({
      message: title,
      description: message,
      placement: "top",
    });
  },
  info_no_time: (title, message) => {
    notification.info({
      message: title,
      description: message,
      placement: "top",
      duration:0,
    });
  },
};
